import { ApplicationState } from '@/redux/store'
import { put, select } from 'redux-saga/effects'
import { fetchRepliesByCompanyAction, updateQuickReplyAction } from '../../actions'
import { update } from '../_http/reply'

export function* updateQuickReplySaga(action: ReturnType<typeof updateQuickReplyAction.request>) {
  const { quickReplyId, dataToUpdate } = action.payload
  try {
    yield update(quickReplyId, dataToUpdate)
    yield put(updateQuickReplyAction.success())

    const companyState = yield select((state: ApplicationState) => state.companyReducer)

    yield put(fetchRepliesByCompanyAction.request({ companyId: companyState?.selectedCompany, operatorId: null }))
  } catch (error) {
    yield put(updateQuickReplyAction.failure())
  }
}
